import { $api } from "../../../../services/request.config";
import {
    DISMISSAL_REVOCATION_UPDATE_DRAFT,
    MATERNITY_UPDATE_DRAFT,
    STUDY_LEAVE_UPDATE_DRAFT,
} from "../../../../enums/Request/applicationUrls";

import moment from "moment/moment";

function applicationUrl(option, uid) {
    switch (option) {
    case 5:
        return STUDY_LEAVE_UPDATE_DRAFT;
    case 6:
        return MATERNITY_UPDATE_DRAFT;
    case 14:
        return DISMISSAL_REVOCATION_UPDATE_DRAFT;
    default:
        return "v1/leaverequest";
    }
}

export const updateCurrentRequestThunk =
    (request, modal, setIsUploading, setModalError) => async (dispatch) => {
        try {
            if (request.dateFrom)
                request.dateFrom = moment(request.dateFrom).format("YYYY-MM-DD");
            if (request.dateTo)
                request.dateTo = moment(request.dateTo).format("YYYY-MM-DD");
            if (request.periods && request.periods[0]?.dateFrom === null)
                delete request.periods;
            let response;
            const temp = applicationUrl(request.leaveTypeId);
            if (request.leaveTypeId === 7) {
                response = await $api.post("v1/requests/leaves/parental", {
                    ...request,
                    uid: request.uid,
                });
                if (response.status === 200) {
                    modal &&  modal(true);
                }
            } else {
                response = await $api.put(`${temp}`, {
                    ...request,
                    uid: request.uid,
                });
                if (response.status === 200) {
                    modal &&   modal(true);
                }
            }

        } catch (error) {
            modal && modal(false);
            setModalError({
                sign: false,
                validation: false,
                status: true,
                saving: true,
            });


        }
    };
